<template>
  <component :is="selectedIcon" :class="iconClass" />
</template>

<script setup>
import GraphIcon from "@/assets/graph_icon.svg";
import TakeoffIcon from "@/assets/takeoff_icon.svg";
import BoxIcon from "@/assets/box_icon.svg";
import QuoteIcon from "@/assets/quote_icon.svg";
import ContractIcon from "@/assets/contract_icon.svg";
import MessageIcon from "@/assets/message_icon.svg";
import BarsIcon from "@/assets/bars_icon.svg";
import SingleFlight from "@/assets/single_airplane.svg";
import MultipleFlight from "@/assets/multiple_airplane.svg";
import FerryFlight from "@/assets/ferry.svg";
import LifeSaverIcon from "@/assets/lifesaver_icon.svg";
import GearIcon from "@/assets/gear_icon.svg";

import {computed} from "vue";

const props = defineProps({
  name: String, // generic icon key, e.g. 'graph', 'box', 'ferry'
  color: {type: String, default: "currentColor"}
});

const icons = {
  graph: GraphIcon,
  takeoff: TakeoffIcon,
  box: BoxIcon,
  quote: QuoteIcon,
  contract: ContractIcon,
  message: MessageIcon,
  bars: BarsIcon,
  single: SingleFlight,
  multiple: MultipleFlight,
  ferry: FerryFlight,
  lifesaver: LifeSaverIcon,
  gear: GearIcon
};

const selectedIcon = computed(() => icons[props.name]);
const iconClass = computed(() => `text-${props.color}`);
</script>